import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollTo } from 'react-scroll';
import { Element } from 'react-scroll';

const Banner = () => {
    
  return (
    <Element
      name="MaritimeSolutions"
      className="aura-ai-banner banner-style-1 height-640 d-flex align-items-center"
    >
      <div className="container eduvibe-animated-shape">
        <div className="row g-5 align-items-center">
          <div className="order-1 order-xl-1 col-lg-12 col-xl-7 banner-left-content">
            <div className="inner">
              <div className="content position-relative">
                <div className="datatalent-jobseekers-breadcrumb d-flex align-items-center color-body2">
                  <Link className="color-body2" to="/">Home</Link>
                  <i className="ri-arrow-drop-right-line"></i>
                  Agriculture
                </div>
                <h1 className="datatalent-program-title color-white title mt-4"><span className="product-banner-title">Maritime</span> Industry Solutions</h1>
                <p className="product-description">Powering Smart, Sustainable Maritime Operations with our AI solutions</p>
                <p className="color-body2">The Maritime sector is undergoing a digital transformation, driven by the need to reduce emissions, optimize vessel operations, and improve safety in harsh and remote environments. M2M Tech delivers Edge AI-powered solutions that enable real-time decision-making, predictive analytics, and intelligent automation across the maritime ecosystem.</p>
                <div className="read-more-btn banner-btns">
                  <ScrollTo
                    className="edu-btn btn-secondary text-center"
                    to="AISolutions"
                    spy={true}
                    smooth={true}
                    duration={200}
                  >
                    Learn More<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </ScrollTo>
                  <Link className="edu-btn btn-primary text-center" to="/contact-us">
                    Contact Us<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="order-2 order-xl-3 col-lg-12 col-xl-5 d-flex flex-column align-items-center justify-content-center banner-right-content">
            <img className="edge-ai-banner-right-image" src={`${process.env.PUBLIC_URL}/images/solutions/illustration_maritime.png`} alt="M2M Edge AI device" loading="lazy" />
          </div>
        </div>
      </div>
    </Element>
  )
}

export default Banner;